import {TopEleven} from '../resources/TopEleven';
import {DomainEvent} from './DomainEvent';

export class TopElevenUpdated extends DomainEvent<TopEleven> {}
